var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"card",class:_vm.couponColor(),on:{"click":_vm.action}},[_c('div',{staticClass:"image"},[_c('img',{attrs:{"src":_vm.image}}),_c('div',{staticClass:"expire"},[_vm._v("\n      "+_vm._s(this.expireAtStr)+"\n    ")]),(
        (this.prize_type === '1' ||
          this.prize_type === '2' ||
          this.prize_type === '3') &&
        _vm.isExpiredDate(this.expireAt) == '0'
      )?_c('div',{staticClass:"button_area"},[_c('img',{attrs:{"src":require("@/assets/img/coupon/freepass_use01.png")}})]):(
        (this.prize_type === '1' ||
          this.prize_type === '2' ||
          this.prize_type === '3') &&
        _vm.isExpiredDate(this.expireAt) == '1'
      )?_c('div',{staticClass:"button_area"},[_c('img',{attrs:{"src":require("@/assets/img/coupon/freepass_use_expire01.png")}})]):(
        this.prize_type === '4' && _vm.isExpiredDate(this.expireAt) == '0'
      )?_c('div',{staticClass:"button_area"},[_c('img',{attrs:{"src":require("@/assets/img/coupon/freepass_use02.png")}})]):(
        this.prize_type === '4' && _vm.isExpiredDate(this.expireAt) == '1'
      )?_c('div',{staticClass:"button_area"},[_c('img',{attrs:{"src":require("@/assets/img/coupon/freepass_use_expire02.png")}})]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }